// uiSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UIState {
  stickyOffset: number;
}

const initialState: UIState = {
  stickyOffset: 0,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setStickyOffset(state, action: PayloadAction<number>) {
      state.stickyOffset = action.payload;
    },
  },
});

export const { setStickyOffset } = uiSlice.actions;
export default uiSlice.reducer;
